import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const statusLineSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28"><path fill="currentColor" fill-rule="evenodd" d="M7 7h14a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2ZM5 8c0-1.1.9-2 2-2h14a2 2 0 1 1 0 4H7a2 2 0 0 1-2-2Zm13 5H6v1h12v-1Zm0 4H6v1h12v-1ZM6 21h12v1H6v-1Z"></path></svg>
)

const StatusLineIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {statusLineSvg}
    </SvgIcon>
)

export default StatusLineIcon